import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import API_URL from "../../ApiUrl/ApiUrl";

import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const OfferCar = () => {
  const [carData, setCarData] = useState({
    carName: '',
    carPrice: '',
    carDescription: '',
    year: '',
    make: '',
    model: '',
    seats: '',
    doors: '',
    discount: '',
    images: [] 
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setCarData({ ...carData, [name]: value });
  };

  const handleFileChange = (e) => {
    setCarData({ ...carData, images: Array.from(e.target.files) });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    
 
    for (const key in carData) {
      if (key !== 'images') {
        formData.append(key, carData[key]);
      }
    }
    
    carData.images.forEach((file, index) => {
      formData.append('images', file);
    });

    try {
      const response = await axios.post(`${API_URL}/car`, formData);
      toast.success('Car added successfully!');
    } catch (error) {
      toast.error('Failed to add car. Please try again.');
    }
    setCarData({
      carName: '',
      carPrice: '',
      carDescription: '',
      year: '',
      make: '',
      model: '',
      seats: '',
      doors: '',
      discount:'',
      images: [] ,
      offer:true

    })

  };

  return (
    <div>
      <ToastContainer />
      <div className="content-wrapper pb-2 mb-0">
        <div className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6">
                <h3 className="m-0 text-dark">Add Offer Car</h3>
              </div>
              <div className="col-sm-6">
                <ol className="breadcrumb float-sm-right">
                  <li className="breadcrumb-item">
                    <Link to="/dashboard">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active">Add Car</li>
                </ol>
              </div>
            </div>
          </div>
        </div>
        <section className="content">
          <div className="container-fluid">
            <form onSubmit={handleSubmit} className="card" encType="multipart/form-data">
              <div className="card-body">
                <div className="row">
                  <div className="col-sm-6 col-md-4">
                    <label className="form-label">
                      Car Images<span className="form-required">*</span>
                    </label>
                    <div className="form-group">
                      <input
                        type="file"
                        name="car_images"
                        className="form-control"
                        multiple
                        onChange={handleFileChange}
                        required
                      />
                    </div>
                  </div>
                  <div className="col-sm-6 col-md-4">
                    <label className="form-label">Car Name</label>
                    <div className="form-group">
                      <input
                        type="text"
                        name="carName"
                        className="form-control"
                        placeholder="Car Name"
                        onChange={handleInputChange}
                        required
                      />
                    </div>
                  </div>
                  <div className="col-sm-6 col-md-4">
                    <label className="form-label">Price</label>
                    <div className="form-group">
                      <input
                        type="text"
                        name="carPrice"
                        className="form-control"
                        placeholder="Car Price"
                        onChange={handleInputChange}
                        required
                      />
                    </div>
                  </div>
                  <div className="col-sm-6 col-md-4">
                    <label className="form-label">Offer</label>
                    <div className="form-group">
                      <input
                        type="text"
                        name="discount"
                        className="form-control"
                        placeholder="Discount %"
                        onChange={handleInputChange}
                        required
                      />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-12 col-md-12">
                    <label className="form-label">Description</label>
                    <div className="form-group">
                      <textarea
                        className="form-control"
                        name="carDescription"
                        placeholder="Car Description"
                        onChange={handleInputChange}
                        required
                      />
                    </div>
                  </div>
                </div>
                <h4 className="mt-4">Key Information</h4>
                <div className="row">
                 
                  {/* Example for Year */}
                  <div className="col-sm-6 col-md-4">
                    <label className="form-label">Year</label>
                    <div className="form-group">
                      <input
                        type="text"
                        name="year"
                        className="form-control"
                        placeholder="Year"
                        onChange={handleInputChange}
                        required
                      />
                    </div>
                  </div>
                  <div className="col-sm-6 col-md-4">
                    <label className="form-label">Make</label>
                    <div className="form-group">
                      <input
                        type="text"
                        name="make"
                        className="form-control"
                        placeholder="Make"
                        onChange={handleInputChange}
                        required
                      />
                    </div>
                  </div>
                  <div className="col-sm-6 col-md-4">
                    <label className="form-label">Model</label>
                    <div className="form-group">
                      <input
                        type="text"
                        name="model"
                        className="form-control"
                        placeholder="Model"
                        onChange={handleInputChange}
                        required
                      />
                    </div>
                  </div>
                  <div className="col-sm-6 col-md-4">
                    <label className="form-label">Seats</label>
                    <div className="form-group">
                      <input
                        type="text"
                        name="seats"
                        className="form-control"
                        placeholder="Seats"
                        onChange={handleInputChange}
                        required
                      />
                    </div>
                  </div>
                  <div className="col-sm-6 col-md-4">
                    <label className="form-label">Doors</label>
                    <div className="form-group">
                      <input
                        type="text"
                        name="doors"
                        className="form-control"
                        placeholder="Doors"
                        onChange={handleInputChange}
                        required
                      />
                    </div>
                  </div>
                </div>
                <div className="card-footer text-right mt-2">
                  <button type="submit" className="btn btnsoft btn-primary">
                    Add Car
                  </button>
                </div>
              </div>
            </form>
          </div>
        </section>
      </div>
    </div>
  );
};

export default OfferCar;
